import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";

const userRightsReducer = (state = initialState.userRights, action) => {
  switch (action.type) {
    case actionTypes.LOAD_USER_RIGHTS_STARTED: {
      return {
        ...state,
        loading: true
      };
    }

    case actionTypes.LOAD_USER_RIGHTS_SUCCESS:
      return {
        data: action.payload,
        loading: false,
        loaded: true
      };

    case actionTypes.INVALIDATE_USER_RIGHTS:
      return Object.assign({}, { loading: false, loaded: false });

    default:
      return state;
  }
};

export default userRightsReducer;
